import React, { useEffect, useState, useContext } from 'react';
import authenticate from '../../utils/Authenticate';
import UserContext from '../../contexts/UserContext';
import { formatMoney } from '../../utils/currency';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import EditDishModal from './EditDishModal'; // Import the modal component

const DishDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [dish, setDish] = useState(null);
  const [message, setMessage] = useState('');
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const { user,setUser } = useContext(UserContext);

  useEffect( () => {
    async function startup(){
      if(!user){
        await authenticate(setUser,navigate);
      }
    }
    startup();
  },[user])

  
  const fetchDishDetails = () => {
    axios.get(`${process.env.REACT_APP_API_URI}/api/dish/viewdishWithIngridents?id=${id}`, { withCredentials: true })
      .then(res => {
        setDish(res.data.data);
      })
      .catch(err => {
        setMessage("Failed to load dish details");
      });
  };

  useEffect(() => {
    fetchDishDetails();
  }, [id]);

  const handleEditSave = (updatedDish) => {
    // Refresh the dish details after successful edit
    fetchDishDetails();
  };

  if (!dish) return <div className="p-4">Loading...</div>;

  return (
    <div className="w-full">
      {/* Header Section */}
      <div className="mb-6 bg-lime-800 p-4 flex items-center">
        <div className="mr-4 cursor-pointer" onClick={() => navigate(-1)}>
          <span className="text-xl text-white">←</span>
        </div>
        <div className="flex-grow text-center">
          <h2 className="text-2xl font-semibold text-white mb-2">{dish.name}</h2>
          <div className="flex flex-col items-center justify-between">
            <span className="text-sm text-lime-300">Quantity:</span>
            <span className="text-lg text-white">
              <strong>{dish.quantity} {dish.unit}</strong>
            </span>
          </div>
        </div>
      </div>

      {/* Ingredients List styled like OpenMiqaat */}
      <h2 className="text-xl font-semibold px-4 text-gray-800 mb-4 text-center">Ingredients</h2>

      <div className="max-w-md mx-auto px-4 pb-20">
        {dish.ingredients.length > 0 ? (
          <div className="rounded shadow border border-gray-200 w-full overflow-hidden bg-white">
            <ul>
              {dish.ingredients.map((ing, index) => (
                <li key={index} className="border-b last:border-b-0 p-2 px-3">
                  <div className="flex flex-col sm:flex-row justify-between items-start py-2 sm:items-center">
                    <div className="flex-grow">
                      <h1 className="font-bold text-[16px] text-yellow-600">
                        {ing.name?.name}
                      </h1>
                      <p className="text-gray-500 text-sm">{ing.name?.category}</p>
                    </div>
                    <div className="items-center space-x-2 sm:ml-4 text-right">
                      <span className="text-lg font-bold text-gray-700">{ing.quantity}</span>
                      <span className="text-sm text-gray-500">{ing.name?.unit}</span>
                      <br></br>
                      <span className="text-sm text-gray-500">{formatMoney(user, ing.name.basePrice)} / {ing.name.unit}</span>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        ) : (
          <div className="bg-yellow-100 text-yellow-800 p-4 rounded">
            No ingredients found for this dish.
          </div>
        )}

        {message && (
          <div className="mt-4 bg-red-100 text-red-500 p-4 rounded">
            {message}
          </div>
        )}
      </div>
      
      {/* Edit Button */}
      <div className='flex'>
        <button 
          onClick={() => setIsEditModalOpen(true)} 
          className="!mx-auto bg-lime-800 text-white py-2 px-4 rounded hover:bg-lime-600"
        >
          Edit Dish
        </button>
      </div>

      {/* Edit Modal */}
      <EditDishModal
        isOpen={isEditModalOpen}
        onClose={() => setIsEditModalOpen(false)}
        dish={dish}
        onSave={handleEditSave}
      />
    </div>
  );
};

export default DishDetails;